<template>
    <a-locale-provider :locale="antdLocale">
        <router-view />
    </a-locale-provider>
</template>

<script>

import axios from 'axios'
// antd 组件内置文案(日期月份/星期/分页等)跟随系统语言
import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN';
import en_US from 'ant-design-vue/lib/locale-provider/en_US';

export default {
  name: 'App',
  computed: {
    antdLocale() {
      const abp = window.abp;
      const lang = abp && abp.localization && abp.localization.currentLanguage
        ? abp.localization.currentLanguage.name
        : 'zh-Hans';
      return lang && lang.indexOf('zh') === 0 ? zh_CN : en_US;
    },
  },
  created() {
    // axios.get('http://localhost:6298/api/TokenAuth/WhoAmI/whoami', { withCredentials: true })
    //   .then(response => {
    //     console.log(response);
    //     const domainUser = response.data.token;
    //     console.log(domainUser);
    //     return axios.post('http://localhost:6298/api/TokenAuth/AutoLogin/autologin', { domainUser });
    //   })
    //   .then(response => {
    //     const token = response.data.token;
    //     localStorage.setItem("token", token);
    //     axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    //     this.$router.push("/home");
    //   })
    //   .catch(err => {
    //     console.error("自动登录失败", err);
    //     // 可选：跳回登录页
    //   });
  }
}

// export default {};
</script>
<style lang="less">
#app {
    height: 100%;
}
</style>
